module.exports = __webpack_public_path__ + "img/panda_config_icon.1553eead.svg";